/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_SavedInputs */



/**
* | output |
* | --- |
* | "Saved. The space is syncing with the new settings." |
*
* @param {Spaces_Connection_Settings_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_saved = /** @type {((inputs?: Spaces_Connection_Settings_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gespeichert. Der Space wird mit den neuen Einstellungen synchronisiert.")
	return /** @type {LocalizedString} */ ("Saved. The space is syncing with the new settings.")
});